import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import Bold from "./TicketBold.woff2";

export const TicketBoldFontFaces: ExcalidrawFontFaceDescriptor[] = [
  // Thin  ExtraLight  Light  Regular  Medium  SemiBold  Bold  ExtraBold
  { uri: Bold },
];
